import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { INotification, defaultValue } from 'app/shared/model/notification.model';
import { getDestinataires } from './destinataire.reducer';

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<INotification>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
  totalItems: 0,
};

const apiUrl = 'api/notification';

// Actions

export const getNotifications = createAsyncThunk('notification/fetch_notification_list', async (entity: any) => {
  const requestUrl = `${apiUrl}?ecoleId=${entity.ecoleId}&page=${entity.page}&size=${entity.size}`;
  return axios.get<INotification[]>(requestUrl);
});

export const getNotification = createAsyncThunk(
  'notification/fetch_notification',
  async (id: string | number) => {
    const requestUrl = `${apiUrl}/${id}`;
    return axios.get<INotification>(requestUrl);
  },
  { serializeError: serializeAxiosError }
);

export const createNotification = createAsyncThunk(
  'notification/create_notification',
  async (entity: INotification, thunkAPI) => {
    const result = await axios.post<INotification>(`${apiUrl}/parents`, cleanEntity(entity));
    thunkAPI.dispatch(getDestinataires(entity));
    return result;
  },
  { serializeError: serializeAxiosError }
);
export type NotificationState = Readonly<typeof initialState>;
export const NotificationSlice = createEntitySlice({
  name: 'notification',
  initialState: initialState as NotificationState,
  extraReducers(builder) {
    builder
      .addCase(getNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.entity = action.payload.data;
      })
      .addMatcher(isFulfilled(getNotifications), (state, action) => {
        return {
          ...state,
          loading: false,
          entities: action.payload.data,
          totalItems: parseInt(action.payload.headers['x-total-count'], 10),
        };
      })
      .addMatcher(isFulfilled(createNotification), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
        state.entity = action.payload.data;
      })
      .addMatcher(isPending(getNotifications, getNotification), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      })
      .addMatcher(isPending(createNotification), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      });
  },
});

export const { reset } = NotificationSlice.actions;

// Reducer
export default NotificationSlice.reducer;
